<template>
  <v-container class="main">
    <div class="mt-5 pt-5 display-3 text-center orange--text">
      Omentum
    </div>
    <div class="title font-weight-light text-center orange--text">
      Cover everything
    </div>
    <div class="text-center ma-5">
      <v-btn depressed rounded color="blue" dark large @click="$router.push({name: 'Home'})">Access Content</v-btn>
    </div>

    <v-layout row justify-center>
      <v-flex xs10 md8 lg6>
        <v-card flat class="pa-5 orange--text mt-5">
          <div class="title">What is Omentum?</div>
          <p class="grey--text text--darken-2">
            Omentum is a spaced-repetition learning tool designed to help medical students learn and reinforce content.
          </p>
          <div class="title">How can I access Omentum?</div>
          <p class="grey--text text--darken-2">
            Anyone can access the tool, but some content is reserved for UC Davis Medical Students and Residents. If you're interested in learning more or working with us, please <a href="mailto:inquiry@omentum.app">email us</a>.
          </p>
        </v-card>

      </v-flex>
    </v-layout>
    <div>
      <div class="mt-5 pt-5 overline text-center blue--text">
        Cards Practiced

      </div>
      <div class="text-center display-2 blue--text">
          {{counter}}
      </div>      

    </div>


    <div class="mt-10 pt-5 display-1 text-center orange--text">
      Team
    </div>
    <v-layout row justify-center>
      <v-flex xs12 md4 lg4
        v-for="(member, index) in team"
        :key="index"
        >
        <v-card flat class="ma-3 pa-5 text-center">
          <div class="title">{{member.name}} </div>
          <div class="heading">{{member.role}} </div>
          <div class="heading">{{member.level}} </div>
          <div class="heading">{{member.other}} </div>
         
        </v-card>
        

      </v-flex>
    </v-layout>  


  </v-container>
</template>

<script>
import firebase from 'firebase'

export default {
    name: 'Landing',
    data() {
      return {
        counter: null,
        team: [
          {
            name: 'Brandon Fennell, M.D., M.S.',
            role: 'Founder and Lead Developer',
            level: 'UCSF IM Resident',
            other: "UC Davis SOM Class '23"
          },
          {
            name: 'Samantha Wong, M.D., M.S.',
            role: 'Co-Director of Content Creation',
            level: 'UW IM Resident',
            other: "UC Davis SOM Class '24"
          },
          {
            name: 'Joseph Bisoglio, M.D.',
            role: 'Co-Director of Content Creation',
            level: 'Mayo Clinic Psychiatry Resident',
            other: "UC Davis SOM Class '23"
          },  
          {
            name: 'Kenneth Beck, Ph.D.',
            role: 'Content Expert',
            level: 'Professor, UC Davis School of Medicine'
          },   
          {
            name: 'Paul Aronowitz, M.D., M.A.C.P',
            role: 'Content Expert',
            level: 'Professor, UC Davis School of Medicine'
          },  
          {
            name: 'Sailabala Vanguri, M.D.',
            role: 'Content Expert',
            level: 'Assistant Professor, UC Davis SOM'
          },                                                 
        ]

      }
    },
    mounted() {
      firebase.firestore().collection('metrics').doc('metrics').onSnapshot(doc => {
        this.counter = doc.data().logs
      })
      firebase.analytics().logEvent('landing_view' )

    }

};
</script>

<style>
.main {
  height: 100%;
  width: 100%;

}
</style>
